import React, { useMemo, useState } from 'react';
import styles from './AddGoal.module.scss';
import Close from '../../assets/icons/Close_MD.svg';
import Preview from '../../assets/images/Preview.png';

function formatDeadlineDraft(v) {
  const digits = String(v || '')
    .replace(/\D/g, '')
    .slice(0, 8); // DDMMYYYY
  const d = digits.slice(0, 2);
  const m = digits.slice(2, 4);
  const y = digits.slice(4, 8);

  if (digits.length <= 2) return d;
  if (digits.length <= 4) return `${d}.${m}`;
  return `${d}.${m}.${y}`;
}

function normalizeDeadline(draft) {
  const s = String(draft || '').trim();

  // DD.MM.YY or DD.MM.YYYY
  const m = s.match(/^(\d{2})\.(\d{2})\.(\d{2}|\d{4})$/);
  if (!m) return s;

  const dd = m[1];
  const mm = m[2];
  let yy = m[3];

  if (yy.length === 2) {
    const n = Number(yy);
    yy = String(n < 70 ? 2000 + n : 1900 + n);
  }

  return `${dd}.${mm}.${yy}`;
}

const SaveGoalForm = ({ value, onChange }) => {
  const [isCommentOpen, setIsCommentOpen] = useState(false);

  const set = (patch) => onChange((prev) => ({ ...prev, ...patch }));

  const previewSrc = useMemo(() => {
    const u = (value.image_url || '').trim();
    return u ? u : Preview;
  }, [value.image_url]);

  const [deadlineDraft, setDeadlineDraft] = useState(value.deadline || '');

  React.useEffect(() => {
    setDeadlineDraft(value.deadline || '');
  }, [value.deadline]);

  return (
    <div className={styles.save__inner}>
      <div className={styles.form__labels}>
        <label className={styles.form__label}>
          <span className={styles.form__labelText}>Название</span>
          <input
            type='text'
            placeholder='Например: Клавиатура'
            className={styles.form__input}
            value={value.title}
            onChange={(e) => set({ title: e.target.value })}
          />
        </label>

        <div className={styles.form__values}>
          <label className={styles.form__label}>
            <span className={styles.form__labelText}>Финальная</span>
            <input
              type='number'
              placeholder='15 000 ₽'
              className={styles.form__input}
              value={value.target_amount}
              onChange={(e) => set({ target_amount: e.target.value })}
            />
          </label>

          <label className={styles.form__label}>
            <span className={styles.form__labelText}>Начальная</span>
            <input
              type='number'
              className={styles.form__input}
              placeholder='2 000 ₽'
              value={value.start_amount}
              onChange={(e) => set({ start_amount: e.target.value })}
            />
          </label>
        </div>

        <label className={styles.form__label}>
          <span className={styles.form__labelText}>
            Ссылка на товар (необязательно)
          </span>
          <input
            type='text'
            placeholder='Например: https://ozon.ru/мой-товар'
            className={styles.form__input}
            value={value.product_url || ''}
            onChange={(e) => set({ product_url: e.target.value })}
          />
        </label>

        <label className={`${styles.form__label} ${styles.form__picture}`}>
          <div className={styles.img__block}>
            <img
              src={previewSrc}
              alt=''
              className={styles.form__img}
              onError={(e) => {
                e.currentTarget.src = Preview;
              }}
            />
          </div>

          <div className={styles.form__block}>
            <span className={styles.form__labelText}>Ссылка на картинку</span>
            <input
              type='text'
              placeholder='https://.../image.jpg'
              className={styles.form__input}
              value={value.image_url || ''}
              onChange={(e) => set({ image_url: e.target.value })}
            />
            <p className={styles.picture__help}>Где взять ссылку?</p>
          </div>
        </label>

        <label className={`${styles.form__label} ${styles.deadline}`}>
          <span className={styles.form__labelText}>
            Дедлайн (необязательно)
          </span>

          <input
            type='text'
            className={styles.form__input}
            placeholder='ДД.ММ.ГГГГ'
            inputMode='numeric'
            value={deadlineDraft}
            onChange={(e) => {
              const formatted = formatDeadlineDraft(e.target.value);
              setDeadlineDraft(formatted);

              // пока печатает — сохраняем как есть (с автоточками)
              set({ deadline: formatted });
            }}
            onBlur={() => {
              // при уходе — нормализуем ГГ -> ГГГГ
              const normalized = normalizeDeadline(deadlineDraft);
              setDeadlineDraft(normalized);
              set({ deadline: normalized });
            }}
          />
        </label>

        <div className={styles.accordion}>
          <button
            type='button'
            className={styles.accordion__toggle}
            onClick={() => setIsCommentOpen((v) => !v)}
            aria-expanded={isCommentOpen}>
            <span
              className={`${styles.accordion__icon} ${
                isCommentOpen ? styles.accordion__iconActive : ''
              }`}
              aria-hidden='true'>
              <img src={Close} alt='' />
            </span>
            <span className={styles.accordion__text}>
              Комментарий (необязательно)
            </span>
          </button>

          <div
            className={`${styles.accordion__content} ${
              isCommentOpen ? styles.accordion__contentOpen : ''
            }`}>
            <div className={styles.accordion__inner}>
              <label className={styles.form__label}>
                <textarea
                  className={styles.form__textarea}
                  placeholder='Зачем / Для чего'
                  value={value.comment}
                  onChange={(e) => set({ comment: e.target.value })}
                  rows={3}
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveGoalForm;
